import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { ThemeProvider } from 'emotion-theming';
import { css, Global } from '@emotion/core';
import { useLocale, useTexts } from '@devsisters/gatsby-plugin-i18n';
import useHelloBraveCookiesSearchParams from '~/src/misc/useHelloBraveCookiesSearchParams';
import OpenGraph from '~/src/components/OpenGraph';
import styled from '@emotion/styled';

interface PageProps {
  location: Location;
}
const Page: React.FC<PageProps> = ({ location }) => {
  const { mid } = useHelloBraveCookiesSearchParams(location);
  const locale = useLocale();
  const t = useTexts();
  useEffect(() => {
    window.location.href = `https://crp.onelink.me/nbbb/8bac5105?link=devsisters-crpuz://invite?mid=${mid}`;
  }, []);
  return (
    <ThemeProvider theme={{ breakpoints: ['640px'] }}>
      <Helmet>
        <html lang={locale} />
        <title>{t`new.game.title`}</title>
        {process.env.FACEBOOK_APP_ID && (
          <meta property="fb:app_id" content={process.env.FACEBOOK_APP_ID} />
        )}
      </Helmet>
      <OpenGraph
        url={`${process.env.PUBLIC_URL}/${locale}/cookierunpuzzle/`}
        image={`${process.env.PUBLIC_URL}/cookierunpuzzle/opengraph/${locale}.jpg`}
        title={t`new.game.title`}
        description={t`new.title`}
      />
      <Global styles={globalStyles} />
      <RedirectionText>
        Redirecting ...
      </RedirectionText>
    </ThemeProvider>
  );
};

export default Page;

const globalStyles = css`
  @import url('https://fonts.googleapis.com/css?family=Noto+Sans:300,400,700&font-display=swap');
  @import url('https://fonts.googleapis.com/css?family=Noto+Sans+KR&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Noto+Sans+TC&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Noto+Sans+JP&display=swap');
  @import url('https://fonts.devscookie.com/CookieRun/CookieRun.css');
  html,
  body {
    margin: 0;
    background-color: white;
    line-height: 1;
    font-family: 'CookieRun', 'Noto Sans', sans-serif;
    &:lang(ja) {
      letter-spacing: -0.1em;
      font-family: 'Noto Sans JP', sans-serif;
      font-weight: bold;
    }
    &:lang(ko) {
      font-family: 'CookieRun', 'Noto Sans KR', sans-serif;
    }
    &:lang(zh-Hant) {
      font-family: 'Noto Sans TC', sans-serif;
    }
  }
  * {
    font-family: inherit;
    line-height: inherit;
  }
`;

const RedirectionText = styled('p')`
  margin: 0;
  padding: 10px;
  font-size: 30px;
`;
